import * as yup from 'yup';
import { validateName, validateEmail, validatePassword, validatePin } from 'utils/validation';
import { ADMIN, MAINTENANCE, INVALID } from './constants';
import { RoleItem, Form } from './types';

export const defaultRoles: RoleItem[] = [
  {
    name: 'Admin',
    code: 'ClientAdmin'
  },
  {
    name: 'Read-only Admin',
    code: 'ReadOnlyAdmin'
  },
  {
    name: 'Maintenance',
    code: 'MaintenanceAdmin'
  }
];

export const globalRole: RoleItem[] = [
  {
    name: 'Global Admin',
    code: 'GlobalAdmin'
  }
];

export const validationSchema = yup.object().shape({
  name: validateName(),
  email: validateEmail(),
  password: validatePassword(),
  pinCode: validatePin()
});

export const getInitialForm = (): Form => ({
  role: ADMIN,
  name: '',
  email: '',
  password: '',
  sendAlertEmails: false,
  pinCode: ''
});

/**
 * Checks to see if any of the form values is empty.
 * @param {object} form - form object --> has the shape of getInitialForm returned object
 */
export const getHasEmptyInput = (form: ReturnType<typeof getInitialForm>) => {
  if (form.role === MAINTENANCE) delete form.password;
  return Object.values(form).some((value) => value === '');
};

/**
 * Checks to see if any of validation object values has INVALID
 * @param {object} validation - validation object --> has the shape of validationSchema object
 */
export const getHasInvalidInput = (validation: { [x: string]: string }) => {
  const tempValidation = validation;
  return Object.values(tempValidation).some((value) => value === INVALID);
};
